﻿$.fn.dxCtrlResultCreationCompteFromEmail = function custom_dxCtrlResultCreationCompteFromEmail(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlresultcreationcomptefromemail dx-ctrl");
        this.createInstance(new cdxCtrlResultCreationCompteFromEmail(this, option));
    }
    return this;
}

window.cdxCtrlResultCreationCompteFromEmail = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    function mConstruit() {
        container.empty();
        var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
            fullScreen: true,
            showTitle: false,
            contentTemplate: function (contentElement) {
                contentElement.css({
                    "display": "flex",
                    "align-items": "center",
                    "justify-content": "center"
                })
                var $Div = $("<div style='text-align:center;'/>").appendTo(contentElement)
                $("<div style='margin-bottom:20px;text-align:center;'/>").appendTo($Div).dxCtrlPiedTitleApp({
                    bddCtrl: option.bddCtrl,
                    codeAppli: parametre.code_appli
                })

                $("<div>Votre ticket de support a été soumis à notre équipe</div>").appendTo($Div)
                $("<div>Nous reviendrons rapidement vers vous pour vous apporter une réponse</div>").appendTo($Div)
                $("<div style='margin-bottom:20px;'>via l'adresse email <u>" + option.adresseEmail + "</u></div>").appendTo($Div)
                $("<div></div>").appendTo($Div)
                if (option.urlTicket.length > 0) {
                    $("<div>Vous pouvez consulter votre ticket via l'adresse:</div>").appendTo($Div)
                    $("<a href='" + option.urlTicket + "'>" + option.urlTicket + "</a>").appendTo($Div)
                } else {
                    $("<div>Accédez à vos tickets:</div>").appendTo($Div)
                    $("<a href='" + option.urlCompteSupport + "'>" + option.urlCompteSupport + "</a>").appendTo($Div)
                }

            },
            onShown: function (e) {
                jaugeDemarrage.mHide()
            }
        }).dxCtrlPopupBase("instance")
        popup.show()
    }

    mConstruit();

}